import Vue from 'vue';
import Portal from './Portal';

/**
 * 可以将这个组件视为一个 div，
 * 特别的是，在实际渲染时，
 * 这个组件会在 document.body 创建一个绝对定位的浮动 div，
 * 让浮动 div 和这个组件本体的大小、位置一致，
 * 然后把这个组件的内容物放到那个浮动 div 渲染
 *
 * 场景：在一个 overflow: scroll 或者 overflow: hidden 的容器内，要让某个div的东西能显示出来不被遮蔽
 *
 * 用法： 把需要"飞地"（逃离overflow的元素）用<FloatPortal>包裹住，并且保证<FloatPortal>的宽高位置和被包裹的元素一致（类似一个遮罩）。
 * 为了避免"飞地"在<FloatPortal>不在dom中无法计算宽高位置时乱飞，请设置v-if来保证"飞地"和<FloatPortal>同时消失
 */
const FloatPortal = Vue.extend({
  name: 'FloatPortal',
  props: {
    zIndex: {
      type: Number
    },
    portalStyle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tempPortalStyle: 'opacity: 0'
    };
  },
  mounted() {
    this.syncRaf = requestAnimationFrame(this.syncStyle);
  },
  beforeDestroy() {
    cancelAnimationFrame(this.syncRaf);
  },
  methods: {
    syncStyle() {
      this.syncRaf = requestAnimationFrame(this.syncStyle);
      const {
        anchor,
        portal
      } = this.$refs;
      const {
        zIndex
      } = this;
      if (!anchor || anchor.nodeType !== Node.ELEMENT_NODE) return;
      const {
        left: absLeft,
        top: absTop,
        width,
        height
      } = anchor.getBoundingClientRect();
      const [left, top] = portal.clientToContainerCoordinate(absLeft, absTop);
      let tempPortalStyle = `left:${left}px; top:${top}px; width:${width}px; height: ${height}px; z-index: ${zIndex === undefined ? '' : zIndex}`;
      if (!anchor.offsetParent && anchor.style.position !== 'fixed') {
        // anchor display:none
        tempPortalStyle += ';pointer-events: none;display:none';
      }
      if (this.tempPortalStyle !== tempPortalStyle) this.tempPortalStyle = tempPortalStyle;
    }
  },
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucd-floatPortal-anchor",
      "ref": "anchor"
    }, [h(Portal, {
      "ref": "portal"
    }, [h("div", {
      "class": "ucd-floatPortal-content",
      "ref": "content",
      "style": `${this.tempPortalStyle};${this.portalStyle}`
    }, [this.$slots.default])]), this.$slots.anchor]);
  }
});
export default FloatPortal;
//# sourceMappingURL=FloatPortal.js.map
